import classes from '../style/heroMsg.module.css'

export const HeroSection = () =>{

    return(
        <>
            <section className={`${classes.heroWrapper} flex flex-col gap-4 items-center justify-center`}>
                <h1 
                    className="header capitalize text-center text-[text-h] font-bold py-[0.2rem]" 
                >
                    Let's revolutionize your business
                </h1>
                <h6 className="subheader capitalize text-center" style={{textShadow:'2px 2px 5px rgba(0, 0, 0, 1)'}}>unlock digital potential for growth and success</h6>
            </section> 
        </>
    )
}